import React, { useCallback } from 'react';
import styled from 'styled-components';

import Icon from '@components/dataDisplay/Icons/Icon';
import { dropdownDirMap } from '@components/wrapper/DropdownWrapper';
import { useRecoilState, useRecoilValue } from 'recoil';
import NotiBadge from './NotiBadge';
import { notificationOpenState } from '@atom/setting/jukebox';
import { unreadNotificationsState } from '@atom/setting/notification';

const ButtonWrap = styled.div`
  border-radius: var(--buttonBorderRadius);
  transition: background-color 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  position: relative;

  &:hover {
    background-color: var(--inkColor);
    cursor: var(--hoverCursorURL), pointer;
  }
`;

const Container = styled.div`
  position: relative;
`;

type Props = {
  dropdownDir?: keyof typeof dropdownDirMap | undefined;
  color?: string;
};

function NotificationBtn({ dropdownDir, color }: Props) {
  const [open, setOpen] = useRecoilState(notificationOpenState);
  const unreadList = useRecoilValue(unreadNotificationsState);
  const unreadNumber = unreadList.length;

  const handleNotiOpen = useCallback(() => {
    setOpen((prev) => !prev);
  }, []);

  return (
    <>
      <Container>
        <ButtonWrap onClick={handleNotiOpen}>
          <Icon name="Bell18" color={color} />
          <NotiBadge unreadNumber={unreadNumber} />
        </ButtonWrap>
      </Container>
    </>
  );
}

export default NotificationBtn;
